import { tns } from 'tiny-slider/src/tiny-slider';

class BannerSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: 'gallery',
			autoplay: false,
			autoplayButtonOutput: false,
			speed: 600,
			controls: false,
			nav: true,
			navPosition: 'bottom',
			navContainer: this.nav,
		});
	}
}

export default BannerSlider;
